import styled, { css } from 'styled-components';
import { Button } from '../button/index.js';
import { makeBoxShadow, suppressProps } from '../../utils/index.js';
import { Popover } from '../popover/index.js';
import { Field } from '../field/index.js';
import { Input } from '../input/index.js';
import { ListBox } from '../list-box/list-box.component.js';
import { Text } from '../text/index.js';
import { Stack } from '../stack/stack.component.js';
export const FieldElement = styled(Field) ``;
export const SelectElement = styled.div.withConfig(suppressProps('fullWidth'))(({ fullWidth }) => css `
    align-self: ${fullWidth ? 'initial' : 'flex-start'};
    position: relative;
    width: ${fullWidth && '100%'};
  `);
const MAX_ITEMS = 7;
export const getSelectHeight = (item, itemCount) => {
    const itemsToShow = Math.min(MAX_ITEMS, itemCount);
    const itemsHeight = `${item.height} * ${itemsToShow}`;
    const padding = itemsToShow < MAX_ITEMS ? '0px' : `${item.height} / 2`;
    return `calc(${itemsHeight} + ${padding})`;
};
export const SelectListBox = styled(ListBox).withConfig(suppressProps('desiredListLength'))(({ theme, desiredListLength }) => css `
    min-height: ${getSelectHeight(theme.styles.select.item, 1)};
    max-height: ${getSelectHeight(theme.styles.select.item, MAX_ITEMS)};
    height: ${desiredListLength
    ? getSelectHeight(theme.styles.select.item, desiredListLength)
    : 'unset'};
    overflow-y: auto;
    position: relative;
  `);
export const PopoverContainer = styled(Popover).withConfig(suppressProps('isInModal'))(({ theme, isInModal }) => {
    const { popover } = theme.styles;
    return css `
      padding: ${popover.paddingTopBottom} ${popover.paddingRightLeft};
      box-shadow: ${makeBoxShadow(popover.boxShadow, theme)};
      border-radius: ${popover.borderRadius};
      background: ${popover.backgroundColor};
      z-index: ${isInModal ? theme.zIndices.modal : popover.zIndex};
      overflow-y: hidden;
      display: flex;
      flex-direction: column;
    `;
});
const getPopoverControlErrorStyles = ({ theme, isErrored, }) => {
    if (isErrored)
        return css `
      border-style: ${theme.styles.inputs.base.borderStyle};
      border-width: ${theme.styles.inputs.base.borderWidth};
      border-radius: ${theme.styles.listBoxes.base.borderRadius};
      border-color: ${theme.styles.inputs.states.error.borderColor};
    `;
    return css ``;
};
export const PopoverControlElement = styled(Button).withConfig(suppressProps('isErrored'))(({ theme, fullWidth }) => {
    if (fullWidth)
        return css `
        & > span {
          width: 100%;
          justify-content: space-between;
        }
      `;
    return css `
      max-width: ${theme.styles.select.control.maxWidth};
    `;
}, getPopoverControlErrorStyles);
export const SelectedLabelsElement = styled.span(({ theme }) => css `
    font-weight: ${theme.styles.select.selectedLabel.fontWeight};
  `);
export const FilterInput = styled(Input).attrs({
    variant: 'search',
})(({ theme }) => {
    const { input } = theme.styles.select;
    return css `
    margin: ${input.marginTop} ${input.marginRightLeft} ${input.marginBottom};
  `;
});
export const LoadingSpinnerContainer = styled.div(({ theme: { colors, styles: { listBoxItems, select }, }, }) => css `
    position: absolute;
    width: 100%;
    bottom: ${select.loadingSpinner.paddingBottom};
    background: ${colors.backgrounds[listBoxItems.states.inactive.backgroundColor]};
    height: ${listBoxItems.base.height};
    color: ${colors.controls[listBoxItems.states.inactive.color]};
  `);
export const SelectListItemContainer = styled(Stack)(() => `
    overflow: inherit;
    text-overflow: inherit;
    white-space: inherit;
`);
export const SelectListItemDescription = styled(Text).attrs(({ theme }) => ({
    fontSize: theme.styles.select.itemDescription.fontSize,
    lineHeight: theme.styles.select.itemDescription.lineHeight,
    color: theme.styles.select.itemDescription.color,
})) ``;
export const SelectListItemElement = styled(Text)(() => `
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
`);
//# sourceMappingURL=select.styles.js.map